import { Component, OnInit, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'app-employee-management-page',
  templateUrl: './employee-management-page.component.html',
  styleUrls: ['./employee-management-page.component.css']
})
export class EmployeeManagementPageComponent implements OnInit {

  @Input() $transition$: any;

  stateParams: any;
  employeeId: any;
  employeeName: any;

  constructor(
    public $state: StateService
  ) { }

  ngOnInit() {
    this.stateParams = this.$transition$.params();
    this.employeeId = this.stateParams.employeeId;
    this.employeeName = this.stateParams.employeeName;
  }

  redirectToUrl(url, isReloadRequired) {
    this.$state.go(url, null, { reload: isReloadRequired });
}

}
